import { ReactNode } from 'react';

import Markdown from 'molecules/Markdown';

import styles from './Table.module.css';

type Cell = string | ReactNode;

type Row = Cell[];

type Column = {
  title: string;
};

export type TableProps = {
  rows: Row[];
  columns: Column[];
};

const Table: React.FC<TableProps> = ({ rows, columns }) => (
  <table className={styles.table}>
    <thead className={styles.tableHead}>
      <tr>
        {columns.map((column, index) => (
          <td key={index} className={`font-medium ${styles.tableHeadCell}`}>
            {column.title}
          </td>
        ))}
      </tr>
    </thead>
    <tbody>
      {rows.map((row, rowIndex) => (
        <tr key={rowIndex} className={styles.tableRow}>
          {row.map((cell, cellIndex) => (
            <TableCell
              key={cellIndex}
              cell={cell}
              column={columns[cellIndex]}
            />
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

const TableCell: React.FC<{
  cell: Cell;
  column: Column;
}> = ({ cell, column }) => (
  <td className={styles.tableCell}>
    <p className={`micro font-medium ${styles.mobileTitle}`}>{column.title}</p>
    <div style={{ overflowWrap: 'anywhere' }}>{parseCell(cell)}</div>
  </td>
);

const parseCell = (cell: Cell) => {
  if (typeof cell === 'string') {
    return <Markdown>{cell}</Markdown>;
  }

  return cell;
};

export default Table;
